import React, { useEffect, useState } from 'react';
import { TimePicker, Input, Button, Typography, notification, DatePicker } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { Link, useFetcher, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import useGetApi from '../../services/useGetApi';
import usePost from '../../services/usePost';
import {Form} from 'antd';

const { Paragraph } = Typography;
const { TextArea } = Input;

const ZoomSetting = () => {
  const { id } = useParams();
  const [form] = Form.useForm();

  // State for the form fields as an object
  const [formValues, setFormValues] = useState({});

  const [isPostLoading, postError, postData] = usePost();
  const [
    zoomMeetingIsLoading,
    zoomMeetingError,
    zoomMeetingData,
    getZoomMeeting,
  ] = useGetApi(`course/zoom-live-class/${id}`, [], true);

  useEffect(() => {
    // Fetch Zoom meeting data when component mounts or id changes
    getZoomMeeting(`course/zoom-live-class/${id}`);
  }, [id]);

  useEffect(() => {
    if (zoomMeetingData) {
      
      setFormValues({
        ...zoomMeetingData,
        liveDate: dayjs(zoomMeetingData.liveDate),
        // liveTime: zoomMeetingData.liveTime,
      });
    }
    else{
        setFormValues({
            courseId:id,
            liveDate: dayjs().format("YYYY-MM-DD"),
            liveTime: dayjs().format("HH:mm:ss"),
            noteToStudents: '',
            meetingId: '',
            meetingPassword: '',
            noOfEnrolls: '',
        });
    }
  }, [zoomMeetingData]);

  useEffect(() =>{
    
    form.setFieldsValue(
      {
        id:formValues.id,
        courseId:formValues.courseId,
        liveDate:dayjs(formValues.liveDate),
        liveTime:dayjs(formValues.liveTime, "HH:mm:ss"),
        noteToStudents: formValues.noteToStudents,
        meetingId: formValues.meetingId,
        meetingPassword: formValues.meetingPassword,
        noOfEnrolls:formValues.noOfEnrolls,
      }
    )
  },[formValues])

  // Handle Date Change
  const handleDateChange = (date, dateString) => {
    setFormValues((prevState) => ({
      ...prevState,
      liveDate: dateString,
    }));
  };

  // Handle Time Change
  const handleTimeChange = (time, timeString) => {
    console.log(timeString,'........')
    setFormValues((prevState) => ({
      ...prevState,
      liveTime: timeString,
    }));
  };

  // Handle input change for other fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Handle Save button click
  const handleSave = async () => {

    // Call the post API
    const response = await postData(`course/zoom-live-class/${id}`, formValues, true);
    // if (response) {
    //   console.log('sucess.......')
    // }
  };

  useEffect(() => {
    console.log(formValues,'.........')
  },[formValues])



  return (
    <div className="zoom_live_settings">
      <Form form={form} layout="vertical" onFinish={handleSave} 
       className="zoom_live_settings_left"
      >
      {/* <div className="zoom_live_settings_left"> */}

          <Form.Item
            label="Live class schedule (Date)"
            name="liveDate"
            rules={[{ required: true, message: "Please select the live date!" }]}
          >
            <DatePicker
              onChange={handleDateChange}
              className="zoom_input"
            />
          </Form.Item>


          <Form.Item
            label="Live class schedule (Time)"
            name="liveTime"
            rules={[{ required: true, message: "Please select the live time!" }]}
          >
            <TimePicker
              className="zoom_input"
              onChange={handleTimeChange}
              format="HH:mm:ss"
            />
          </Form.Item>


          <Form.Item label="Note to students"
            name="noteToStudents"
            rules={[{ required: true, message: "Please input note!" }]}
            >
            <TextArea
              rows={4}
              className="zoom_input"
              name="noteToStudents"
              value={formValues.noteToStudents}
              onChange={handleInputChange}
            />
          </Form.Item>

          <Form.Item label="Meeting ID" 
            name="meetingId"
            rules={[{ required: true, message: "Please input MeetingId!" }]}
            >
            <Input
              name="meetingId"
              value={formValues.meetingId}
              onChange={handleInputChange}
            />
          </Form.Item>


          <Form.Item label="Meeting password" name="meetingPassword"
           rules={[{ required: true, message: "Please input meeting password!" }]}
          >
            <Input
              name="meetingPassword"
              value={formValues.meetingPassword}
              onChange={handleInputChange}
              className="zoom_input"
            />
          </Form.Item>

        <div>
          <button
     
            htmlType="submit"
            className="start_live_class_btn"
            loading={isPostLoading}
          >
            Save
          </button>
        </div>
      {/* </div> */}
    </Form>

      <div className="course_enrollment_div">
        <div className="zoom_meeting_plans_card">
          <h4>Course enrollment details</h4>
          <p>
            Number of enrollments: <strong>{formValues.noOfEnrolls}</strong>
          </p>
          <hr />
          <p>Get Zoom Meeting plans that fit your business perfectly.</p>
          <Button className="zoom_meeting_plan_btn">
            Zoom meeting plans <ArrowRightOutlined />
          </Button>
        </div>

        <div className="zoom_meeting_plans_card">
          <Paragraph>
            Both the meeting ID, password, and Zoom settings must be configured from the same Zoom account. If there is more than one teacher in the course, the one who added the course will be considered the course creator. The course creator needs to configure{' '}
            <Link to={'/zoom_live_settings'}>Zoom Live Class settings</Link> and Zoom Live Class.
          </Paragraph>
        </div>

        <div>
          <Button className="start_live_class_btn">Start Live Class</Button>
        </div>
      </div>
    </div>
  );
};

export default ZoomSetting;
